import React from 'react';
import PropTypes from 'prop-types';

export const XLSXIcon = ({ width, height, ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      d='M12.414 3H13.6286V4.67442C15.6755 4.67442 17.7222 4.6786 19.7689 4.66806C20.1145 4.68262 20.4949 4.65767 20.7953 4.86899C21.0059 5.17875 20.9815 5.57224 20.9957 5.92806C20.9856 9.56154 20.9897 13.193 20.9918 16.8243C20.9817 17.4335 21.0469 18.055 20.9223 18.6558C20.8405 19.0912 20.3293 19.1015 19.9878 19.1163C17.8694 19.1225 15.7491 19.1121 13.6286 19.1163V21H12.3587C9.24253 20.4201 6.12012 19.8845 3 19.3256V4.6766C6.13877 4.11767 9.27737 3.56729 12.414 3Z'
      fill='white'
    />
    <path
      d='M13.6286 5.30233H20.3762V18.4884H13.6286V17.2326H15.2644V15.7674H13.6286V14.9302H15.2644V13.4651H13.6286V12.6279H15.2644V11.1628H13.6286V10.3256H15.2644V8.86047H13.6286V8.02326H15.2644V6.55814H13.6286V5.30233Z'
      fill='currentColor'
    />
    <path
      d='M16.0823 6.55814H18.9449V8.02326H16.0823V6.55814Z'
      fill='white'
    />
    <path
      d='M9.05652 8.51922C9.51863 8.48573 9.98287 8.45643 10.4469 8.43349C9.90183 9.57941 9.35181 10.7229 8.79691 11.8639C9.3593 13.036 9.93363 14.1997 10.498 15.3718C10.0057 15.3429 9.51368 15.3108 9.02184 15.2755C8.67423 14.4026 8.25089 13.5592 8.00143 12.6467C7.7235 13.4964 7.32666 14.298 7.00784 15.1312C6.55996 15.1248 6.11208 15.106 5.66436 15.0871C6.18978 14.0344 6.69688 12.9732 7.23865 11.9267C6.77867 10.8487 6.27353 9.79178 5.79915 8.72015C6.249 8.69286 6.69884 8.66573 7.14869 8.64061C7.45327 9.45907 7.78648 10.2668 8.03823 11.1062C8.30797 10.2167 8.71087 9.37954 9.05652 8.51922Z'
      fill='currentColor'
    />
    <path
      d='M16.0823 8.86047H18.9449V10.3256H16.0823V8.86047ZM16.0823 11.1628H18.9449V12.6279H16.0823V11.1628ZM16.0823 13.4651H18.9449V14.9302H16.0823V13.4651ZM16.0823 15.7674H18.9449V17.2326H16.0823V15.7674Z'
      fill='white'
    />

  </svg>
);

XLSXIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

XLSXIcon.defaultProps = {
  width: 24,
  height: 24,
};
